import type { MaterialData } from '../../exports/behaviors';

/**
 * Returns a new materials array with `patch` merged into the given slot.
 *
 * The one place slot lookup-or-append lives: `targetMaterialIndex` is optional
 * and defaults to 0, so `findIndex(m => m.targetMaterialIndex === i)` misses
 * the slot every time an authored entry left it off. Clones the mutated entry
 * instead of editing in place so callers can reuse the input array as an undo
 * snapshot without it getting overwritten.
 */
export function applyMaterialSlotOverride(
    materials: readonly MaterialData[] | undefined,
    targetMaterialIndex: number,
    patch: Omit<MaterialData, 'targetMaterialIndex'>,
): MaterialData[] {
    const out = materials ? [...materials] : [];
    const existingIdx = out.findIndex(m => (m.targetMaterialIndex ?? 0) === targetMaterialIndex);
    if (existingIdx >= 0) {
        out[existingIdx] = { ...out[existingIdx], ...patch };
    } else {
        out.push({ targetMaterialIndex, ...patch });
    }
    return out;
}
